module.exports = __webpack_public_path__ + "media/svg-new/cancel-d0f60ecd.svg";